import React from "react";
import { Input } from "@/components/ui/input";

type Props = {
  name: string;
  setName: (name: string) => void;
  error?: string;
};

export const NameInput: React.FC<Props> = ({ name, setName, error }) => (
  <div className="w-full">
    <Input
      type="text"
      value={name}
      onChange={(e) => setName(e.target.value)}
      placeholder="Enter your full name"
      className={`h-12 px-6 border-2 ${error ? 'border-destructive' : 'border-border'} transition-all duration-200`}
    />
    {error && (
      <p className="text-destructive text-xs mt-1 animate-in fade-in slide-in-from-top-1 duration-200">
        {error}
      </p>
    )}
  </div>
);
